import { RefObject, useEffect, useRef } from 'react'

export function useOutsideClick<TElement extends HTMLElement, TData = never>(
  { onClick }: { onClick: (data?: TData, e?: MouseEvent, node?: TElement) => void },
  data?: TData
) {
  const elementRef: RefObject<TElement | null> = useRef(null)

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick)
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [data])

  const handleOutsideClick = (e: MouseEvent) => {
    if (elementRef.current?.contains(e.target as Node)) {
      return
    }

    onClick(data, e, elementRef.current as TElement)
  }

  return elementRef
}
